/**
 * MessageAttachmentChips — the compact "what rode in on this message" row shown
 * inside a SENT user bubble, live (from the just-uploaded refs) and on reload
 * (from `ConversationDetail.attachments` matched by message id in the turn
 * mappers). Read-only sibling of the composer's AttachmentTray.
 */
import { formatBytes, isImageMime } from './composerAttachments';
import type { MessageAttachment } from './messageAttachments';
import styles from './MessageAttachmentChips.module.css';

export function MessageAttachmentChips({
  attachments,
}: {
  attachments: MessageAttachment[] | undefined;
}) {
  if (!attachments || attachments.length === 0) return null;
  return (
    <ul className={styles.row} aria-label="Attached files">
      {attachments.map((a) => (
        <li className={styles.chip} key={a.id} title={a.filename}>
          <span aria-hidden="true">
            {isImageMime(a.mimeType) ? '🖼️' : '📄'}
          </span>
          <span className={styles.name}>{a.filename}</span>
          <span className={styles.size}>{formatBytes(a.sizeBytes)}</span>
        </li>
      ))}
    </ul>
  );
}
